import { isObject } from '@/common/utils/filter.js'
/* 
  设置localStorage
  json的形式需要传 type： object; 其他的不需要传
*/
export const getItem = (name, type) => type == 'object' ? JSON.parse(window.localStorage.getItem(name) || '{}') : window.localStorage.getItem(name);
export const setItem = (name, value) => {
    isObject(value) ? window.localStorage.setItem(name, JSON.stringify(value)) : window.localStorage.setItem(name, value);
}
export const removeItem = (name) => {
    window.localStorage.removeItem(name);
}

//获取用户信息
export const getUserInfo = () => getItem('userInfo', 'object');


// WEBPACK FOOTER //
// ./src/common/utils/localStorage.js